import styled from "styled-components";

export const ActivityNewsItemStyled = styled.div`
  display: flex;
  column-gap: 12px;
  cursor: pointer;
  .figture_img {
    position: relative;
    flex-shrink: 0;
    flex-basis: 140px;
    .status_line {
      position: absolute;
      bottom: 0px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .activity_news_detail {
    width: 100%;
    .activity_news_title_bar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      column-gap: 10px;
      &:hover {
        .activity_news_title {
          color: ${({ theme }) => theme.COLORS.PURPLE_10};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        }
        .arrow_button {
          svg {
            circle {
              stroke: ${({ theme }) => theme.COLORS.PURPLE_10};
            }
            path {
              fill: ${({ theme }) => theme.COLORS.PURPLE_10};
            }
          }
        }
      }
      .activity_news_title {
        color: ${({ theme }) => theme.COLORS.BLACK_6};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .arrow_button {
        background: none;
        cursor: pointer;
      }
    }
  }
  .activity_news_subtitle {
    color: ${({ theme }) => theme.COLORS.BLACK_6};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.IPAD}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    .activity_news_detail {
      .activity_news_title_bar {
        .arrow_button {
          display: none;
        }
      }
    }
  }
`;
